<template>
  <div class="product_details"><p v-html="product_details"></p></div>
</template>

<script>
export default {
  props: ["product_details"],
};
</script>